import * as yup from 'yup';
var nameRegExp = /^[a-zA-Z ]+(([',. -][a-zA-Z ])?[a-zA-Z ]*)*$/;
var phoneRegExp = /^[(]{0,1}[0-9]{1,4}[)]\s{1}[\0-9]{3}-[0-9]{4}$/;
var zipRegExp = /^\d{5}([-]|\s*)?(\d{4})?$/;
var poBoxRegExp = /\b(?:p\.*\s*\.*o\.*|post\s*office|post\s*box.*|postal|[0-9]*pob|[0-9]*pobo)(\s+)?(?:box|box[0-9]|[0-9]*)\b/; //const zipRegExp = /^([A-Za-z]+(?: [A-Za-z]+)*),? ([A-Za-z]{2})$|^[0-9]{5}(?:-[0-9]{4})?$|^[\w\s]+,\s\w{2}\s\d{5}(?:-[0-9]{4})?$/;

var cityStateZipRegExp = /^([A-Za-z']+(?: [A-Za-z']+)*),? ([A-Za-z']{2})$|^[0-9]{5}(?:-[0-9]{4})?$|^[\w\s]+,\s\w{2}\s\d{5}(?:-[0-9]{4})?$/;
export var validation = {
  firstName: yup.string().strict(false).trim().matches(nameRegExp, 'First name is not valid.').required('First name is required.'),
  lastName: yup.string().strict(false).trim().matches(nameRegExp, 'Last name is not valid.').required('Last name is required.'),
  emailAddress: yup.string().strict(false).trim().email('Invalid email address.').required('Email is required.'),
  cityStateZip: yup.string().strict(false).trim() //.matches(cityStateZipRegExp, 'City and State or Zip Code is not valid.')
  .required('City, State or Zip Code is required'),
  zipCode: yup.string().strict(false).trim().matches(zipRegExp, 'Zip code is not valid.').required('Zip code is required.'),
  phoneNumber: yup.string().strict(false).trim().matches(phoneRegExp, 'Phone number is not valid').required('Phone number is required.'),
  wlEmailAddress: yup.string().when("newsletter", {
    is: true,
    then: yup.string().strict(false).trim().email('Invalid email address.').required('Email is required.')
  }),
  wlZipcode: yup.string().when("newsletter", {
    is: true,
    then: yup.string().strict(false).trim().matches(zipRegExp, 'Zip code is not valid.').required('Zip code is required.')
  }),
  tandc: yup.boolean().oneOf([true], "Please review and accept terms"),
  password: yup.string().required('Password is required.').matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'Password must have a minimum of eight characters with one number and one special character.'),
  confirmPassword: yup.string().required('Confirm password is required.').oneOf([yup.ref('password'), null], 'Passwords must match.'),
  notEmpty: yup.string().required('This field cannot be blank.'),
  cvv: yup.string().when("isTokenExEnabled", {
    is: true,
    then: yup.string().when("paymentMethod", {
      is: function is(val) {
        return val && val.includes("card");
      },
      then: yup.string().required("CVV is required").min(3)
    }),
    otherwise: yup.string().when("paymentMethod", {
      is: function is(val) {
        return val && val.includes("card");
      },
      then: yup.string().required("CVV is required").min(3).max(4)
    })
  }),
  expDate: yup.string().when("paymentMethod", {
    is: function is(val) {
      return val && val.includes("card");
    },
    then: yup.string().required("Expiration date is required")
  }),
  shippingStreetAddress: yup.mixed().when("isDelivery", {
    is: "true",
    then: yup.mixed().test({
      name: 'shippingStreetAddress',
      test: function test(item) {
        var str = (item + '').toLowerCase();
        return !poBoxRegExp.test(str);
      },
      message: 'Sorry, we can\'t ship to a P.O. Box. Please provide a street address to continue.',
      exclusive: true
    }).required("Street Address is needed")
  }),
  shippingStreetAddress2: yup.mixed().when("isDelivery", {
    is: "true",
    then: yup.mixed().test({
      name: 'shippingStreetAddress2',
      test: function test(item) {
        var str = (item + '').toLowerCase();
        return !poBoxRegExp.test(str);
      },
      message: 'Sorry, we can\'t ship to a P.O. Box. Please provide a street address to continue.',
      exclusive: true
    })
  }),
  shippingCity: yup.string().when("isDelivery", {
    is: "true",
    then: yup.string().required("City is needed")
  }),
  shippingState: yup.string().when("isDelivery", {
    is: "true",
    then: yup.string().required("State is needed")
  }),
  shippingZip: yup.string().when("isDelivery", {
    is: "true",
    then: yup.string().required("Postal Code is needed")
  }),
  shippingOther: yup.string().when("isDelivery", {
    is: "true",
    then: yup.string()
  }),
  retailStreetAddress: yup.mixed().when("isRetail", {
    is: "true",
    then: yup.mixed().test({
      name: 'retailStreetAddress',
      test: function test(item) {
        var str = (item + '').toLowerCase();
        return !poBoxRegExp.test(str);
      },
      message: 'Sorry, we can\'t ship to a P.O. Box. Please provide a street address to continue.',
      exclusive: true
    }).required("Street Address is needed")
  }),
  retailStreetAddress2: yup.mixed().when("isRetail", {
    is: "true",
    then: yup.mixed().test({
      name: 'retailStreetAddress2',
      test: function test(item) {
        var str = (item + '').toLowerCase();
        return !poBoxRegExp.test(str);
      },
      message: 'Sorry, we can\'t ship to a P.O. Box. Please provide a street address to continue.',
      exclusive: true
    })
  }),
  retailCity: yup.string().when("isRetail", {
    is: "true",
    then: yup.string().required("City is needed")
  }),
  retailState: yup.string().when("isRetail", {
    is: "true",
    then: yup.string().required("State is needed")
  }),
  retailZip: yup.string().when("isRetail", {
    is: "true",
    then: yup.string().required("Postal Code is needed")
  }),
  retailOther: yup.string().when("isRetail", {
    is: "true",
    then: yup.string()
  }),
  billingStreetAddress: yup.mixed().when("isTokenExEnabled", {
    is: true,
    then: yup.mixed(),
    otherwise: yup.mixed().when("paymentMethod", {
      is: function is(val) {
        return val && val.includes("card");
      },
      then: yup.mixed().test({
        name: 'billingStreetAddressCC',
        test: function test(item) {
          var str = (item + '').toLowerCase();
          return str && str.length > 0;
        },
        message: 'Sorry, Please provide a billing address to continue.',
        exclusive: true
      }).required("Street Address is needed")
    })
  }),
  billingStreetAddress2: yup.mixed().when("paymentMethod", {
    is: function is(val) {
      return val && val.includes("card");
    },
    then: yup.mixed().test({
      name: 'billingStreetAddress2CC',
      test: function test(item) {
        var str = (item + '').toLowerCase();
        return str && str.length > 0; // return !poBoxRegExp.test(str);
      },
      message: 'Sorry, Please provide a billing address to continue.',
      exclusive: true
    })
  }),
  billingCity: yup.string().when("isTokenExEnabled", {
    is: true,
    then: yup.string(),
    otherwise: yup.string().when("paymentMethod", {
      is: function is(val) {
        return val && val.includes("card");
      },
      then: yup.string().required("City is needed")
    })
  }),
  billingZip: yup.string().when("isTokenExEnabled", {
    is: true,
    then: yup.string().matches(/^\d{5}(?:[-\s]\d{4})?$/, "Please enter a valid Postal Code").required("Postal Code is needed"),
    otherwise: yup.string().when("paymentMethod", {
      is: function is(val) {
        return val && val.includes("card");
      },
      then: yup.string().required("Postal Code is needed")
    })
  }),
  billingOther: yup.string().when("paymentMethod", {
    is: function is(val) {
      return val && val.includes("card");
    },
    then: yup.string()
  }),
  curbsideMake: yup.string().when("isCurbside", {
    is: "true",
    then: yup.string().required("Vehicle Make is needed")
  }),
  curbsideModel: yup.string().when("isCurbside", {
    is: "true",
    then: yup.string().required("Car Model is needed")
  }),
  curbsideColor: yup.string().when("isCurbside", {
    is: "true",
    then: yup.string().required("Car Color is needed")
  }),
  giftCardNumber: yup.string().matches(/^\d{19}$/, "Please enter a valid Gift Card Number").required("Gift Card Number is required"),
  giftCardPin: yup.string().matches(/^\d{4}$/, "Please enter a valid Pin Number").required("Pin Number is required"),
  giftCardApplied: yup.boolean().oneOf([true], "Add a valid Gift Card"),
  pickupPhone: yup.string().matches(phoneRegExp, 'Phone number is not valid, please use (###) ###-####'),
  foodDate: yup.string().when("foodTime", {
    is: "scheduled",
    then: yup.string().required("Please Select Date for Food")
  }),
  cateringDate: yup.string().when("isCater", {
    is: true,
    then: yup.string()
  }).when("cateringTime", {
    is: "scheduled",
    then: yup.string().required("Please Select Date for Cater")
  })
};
export function required(message) {
  return yup.string().required(message);
}